import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowTriangleRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconArrowTriangleRight"><Path d="M4.75 17.252V6.74803C4.75 5.26465 6.31162 4.29985 7.63887 4.96324L18.1465 10.2152C19.6178 10.9506 19.6178 13.0494 18.1466 13.7848L7.63888 19.0368C6.31162 19.7001 4.75 18.7354 4.75 17.252Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconArrowTriangleRight;
